import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor() {}

  getBrowser() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'old-edge';
      case agent.indexOf('edg/') > -1:
        return 'edge'; // Match also / to avoid matching for the older Edge
      case agent.indexOf('opr') > -1 && !!(window as any).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(window as any).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  getOS() {
    let platform = 'unknown';
    // 2022 way of detecting. Note : this userAgentData feature is available only in secure contexts (HTTPS)
    if (
      typeof (navigator as any).userAgentData !== 'undefined' &&
      (navigator as any).userAgentData != null
    ) {
      platform = (navigator as any).userAgentData.platform.toLowerCase();
    }
    // Deprecated but still works for most of the browser
    if (typeof navigator.platform !== 'undefined') {
      if (
        typeof navigator.userAgent !== 'undefined' &&
        /android/.test(navigator.userAgent.toLowerCase())
      ) {
        // android device’s navigator.platform is often set as 'linux', so let’s use userAgent for them
        platform = 'android';
      }
      platform = navigator.platform.toLowerCase();
    }

    switch (true) {
      case /mac/.test(platform):
        return 'osx'; // Mac desktop
      case ['iphone', 'ipad', 'ipod'].indexOf(platform) > -1:
        return 'ios';
      case /win/.test(platform):
        return 'windows';
      case /android/.test(platform):
        return 'android';
      case /linux/.test(platform):
        return 'linux';
      default:
        return 'other';
    }
  }
}
